/**
 * @generated SignedSource<<942a6fcca9c99ab8b7c4808afef95d2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type singlePersonKnowledgeCardRelay_reportingLines$data = {
  readonly reportingLines: {
    readonly __typename: "KnowledgeDiscoveryReportingLines";
    readonly managers: ReadonlyArray<{
      readonly accountIdentifier: string | null;
      readonly numberOfDirectReports: number | null;
      readonly numberOfTotalReports: number | null;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null;
        } | null;
        readonly name: string | null;
        readonly picture: string | null;
      } | null;
    }>;
    readonly peers: ReadonlyArray<{
      readonly accountIdentifier: string | null;
      readonly numberOfDirectReports: number | null;
      readonly numberOfTotalReports: number | null;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null;
        } | null;
        readonly name: string | null;
        readonly picture: string | null;
      } | null;
    }>;
    readonly reports: ReadonlyArray<{
      readonly accountIdentifier: string | null;
      readonly numberOfDirectReports: number | null;
      readonly numberOfTotalReports: number | null;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null;
        } | null;
        readonly name: string | null;
        readonly picture: string | null;
      } | null;
    }>;
    readonly user: {
      readonly accountIdentifier: string | null;
      readonly numberOfDirectReports: number | null;
      readonly numberOfTotalReports: number | null;
      readonly pii: {
        readonly extendedProfile: {
          readonly jobTitle: string | null;
        } | null;
        readonly name: string | null;
        readonly picture: string | null;
      } | null;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "singlePersonKnowledgeCardRelay_reportingLines";
};
export type singlePersonKnowledgeCardRelay_reportingLines$key = {
  readonly " $data"?: singlePersonKnowledgeCardRelay_reportingLines$data;
  readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_reportingLines">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "picture"
      },
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "jobTitle"
          }
        ]
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "aaid"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orgId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "siteId"
    }
  ],
  "kind": "Fragment",
  "name": "singlePersonKnowledgeCardRelay_reportingLines",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "aaid",
          "variableName": "aaid"
        },
        {
          "kind": "Variable",
          "name": "orgId",
          "variableName": "orgId"
        },
        {
          "kind": "Variable",
          "name": "siteId",
          "variableName": "siteId"
        }
      ],
      "kind": "LinkedField",
      "name": "reportingLines",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": (v0/*: any*/)
            },
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "managers",
              "plural": true,
              "selections": (v0/*: any*/)
            },
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "reports",
              "plural": true,
              "selections": (v0/*: any*/)
            },
            {
              "concreteType": "KnowledgeDiscoveryReportingLinesUser",
              "kind": "LinkedField",
              "name": "peers",
              "plural": true,
              "selections": (v0/*: any*/)
            }
          ],
          "type": "KnowledgeDiscoveryReportingLines"
        }
      ]
    }
  ],
  "type": "KnowledgeDiscoveryQueryApi"
};
})();

(node as any).hash = "39f148778c4afeaf5cb148a80dda3216";

export default node;
